<template>
  <div v-loading="showFlag">
    <!--  補足データ選択画面 -->
    <t-card>
      <div :style="{ height: basicHeight + 'px' }">
        <t-form
          :model="searchConditionForm"
          label-position="right"
          label-width="100px"
        >
          <t-row type="flex" justify="center">
            <!-- 仕入先 -->
            <t-col :span="6">
              <t-form-item
                :label="$t('resource.orderInfo.supplierCpy')"
                class="marginBottom"
                :placeholder="$t('resource.sys.hidden')"
              >
                <t-select
                  v-model="searchConditionForm.searchSupCode"
                  class="commonDialog"
                  disabled
                >
                  <t-option
                    v-for="item in supCodeList"
                    :key="item.supCode"
                    :label="item.supCode + ':' + item.supAbbreviation"
                    :value="item.supCode"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
            <!-- 注文No. -->
            <t-col :span="6">
              <t-form-item
                :label="$t('resource.CUSTOMER_PAY.ORDER_NO')"
                class="marginBottom"
              >
                <t-input
                  v-model="searchConditionForm.searchOrderNo"
                  class="commonDialog"
                  maxLength="30"
                  clearable
                >
                </t-input>
              </t-form-item>
            </t-col>

            <t-col :span="3"> &nbsp; </t-col>

            <!-- 検索 -->
            <t-col :span="4" class="center">
              <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                ref="searchBtn"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.sys.search") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col :span="1"> &nbsp;</t-col>
          <t-col :span="22">
            <!-- テーブル -->
            <div>
              <t-table
                ref="cusPayCloseSelectTable"
                :data="cusPayCloseSelectTable"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                :cell-class-name="TableCellClassName"
                :row-class-name="rowClassName"
                @row-click="handleRowClick"
                border
                fit
              >
                <!-- 選択ボックス -->
                <t-table-column type="selection" class-name="cell_txt_center" />
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                >
                </t-table-column>

                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                <!-- 課題_備考機能の追加 -->
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓ -->
                <!-- 共通備考の調整 -->
                <!-- <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  class="cell_txt_center"
                  :min-width="100"
                >
                  <template slot-scope="scope">
                    <div class="button-container">
                      <t-tooltip placement="bottom" effect="light">
                        <div
                          slot="content"
                          class="tooltip-content"
                          v-html="
                            formatRemarksShowProc(scope.row.aodProdRemarksSum)
                          "
                        ></div>
                        <t-button
                          :type="getIconTypeProc(scope.row.aodProdRemarksSum)"
                          icon="el-icon-search"
                          size="small"
                          circle
                        >
                        </t-button>
                      </t-tooltip>
                    </div>
                  </template>
                </t-table-column> -->
                <t-table-column
                  :label="$t('resource.REMARKS_ADD.REMARKS')"
                  prop="aodProdRemarksSum"
                  :class-name="'cell_txt_center'"
                  :width="getRemarksColumnWidthProc()"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <div class="bikouDiv">
                      <!-- 備考表示 -->
                      <span class="bikouText">
                        {{ scope.row.aodProdRemarksSum }}
                      </span>
                    </div>
                  </template>
                </t-table-column>
                <!-- UPD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑ -->
                <!-- ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
              </t-table>
            </div>
          </t-col>
          <t-col :span="1"> &nbsp;</t-col>
        </t-row>
      </div>
      <div :style="{ height: bottomHeight + 'px' }">
        <t-form label-position="right">
          <t-row>
            <div>
              <t-col
                :span="
                  parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_THREE'))
                "
                class="right"
              >
                <t-button
                  round
                  type="warning"
                  class="dialogButton_confirm_120_40"
                  ref="confirmBtn"
                  @click="confirmClick"
                >
                  <i class="el-icon-check"></i>
                  {{ $t("resource.sys.sure") }}</t-button
                >
              </t-col>
              <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
                >&nbsp;</t-col
              >
            </div>
          </t-row>
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { t } from "@/locales";
import {
  initCustPaySearchList,
  searchCloseSelectForm,
} from "@/services/customerPayInfo";
import {
  formatCurrencyToNumber,
  formatRemarksShow,
  formatStringToCurrency,
  getDialogContentHeight,
  getIconType,
  getRemarksColumnWidth,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  STR_COLON,
  STR_EMPTY,
  STR_ZERO,
} from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      dateRange: [],
      // //検索条件
      searchConditionForm: {
        searchSupCode: "", // 仕入先
        searchOrderNo: "", // 注文No
      },
      //仕入先リスト
      supCodeList: [],

      //入荷選択テーブル
      cusPayCloseSelectTable: [],
      //入荷選択依頼のテーブルの列
      columns: [
        // 注文No.
        {
          prop: "jrdOrderNoShow",
          label: t("resource.CUSTOMER_PAY.ORDER_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        //品名
        {
          prop: "aodProdName",
          label: t("resource.CUSTOMER_PAY.PRODUCT_NAME"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        //図番
        {
          prop: "aodProdDrawNo",
          label: t("resource.CUSTOMER_PAY.PRODUCT_DRAW_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // //注文数
        // {
        //   prop: "odProdQuantity",
        //   label: t("resource.CUSTOMER_PAY.PRODUCT_COUNT"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        //   overflowTooltip: true,
        // },
        //補足数
        {
          prop: "pdPayQty",
          label: t("resource.CUSTOMER_PAY.SUPPLEMENT_COUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },

        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓

        //補足金額
        // {
        //   prop: "pdSupplementAmount",
        //   label: t("resource.CUSTOMER_PAY.SUPPLEMENT_AMOUNT"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_right",
        // },

        //補足単価
        {
          prop: "pdPayUPrice",
          label: t("resource.CUSTOMER_PAY.SUPPLEMENT_U_PRICE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },

        //補足金額小計
        {
          prop: "pdPayTotPrice",
          label: t("resource.CUSTOMER_PAY.SUPPLEMENT_AMOUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
        },
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑

        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // 製品区分
        // {
        //   prop: "odProdExKbnShow",
        //   label: t("resource.CUSTOMER_PAY.PROD_EX_KBN"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        // },

        // 備考
        // {
        //   prop: "odRemarks",
        //   label: t("resource.CUSTOMER_PAY.REMARKS"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_備考機能の追加
        // {
        //   prop: "odRemarks",
        //   label: t("resource.CUSTOMER_PAY.REMARKS"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_left",
        //   overflowTooltip: true,
        // },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
      ],

      //入荷選択情報
      selectedProcForm: [],
      //現在選択されているセル
      currentCell: null,
      showFlag: false,

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT * 1,
      //明細情報のheight 20:Tableと合計行の間隔調整用(Table的marginTop + bottom)
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        20
      ),
      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,
      // 読み込み回数
      numLoads: 1,

      // 比較用明細情報
      cmpDetailResult: "",
    };
  },

  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    tableData: {
      Type: Object,
      default: null,
    },
    pbSupCode: {
      Type: Object,
      default: null,
    },
    selectCloseSearchForm: {
      Type: Object,
      default: null,
    },
    pbPayNo: {
      Type: Object,
      default: null,
    },
  },
  mounted() {
    this.Init();
    setColumnWidth(this.columns, this.cusPayCloseSelectTable);
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        20
      );
    },

    // 初期化
    Init() {
      this.showFlag = true;

      //検索条件リストの初期化(状態、支払状態)
      initCustPaySearchList()
        .then((res) => {
          //仕入先リストに追加
          this.supCodeList = res.supInfoList;

          //検索条件が空しない場合
          if (
            !!this.selectCloseSearchForm &&
            this.selectCloseSearchForm != STR_EMPTY
          ) {
            this.searchConditionForm = [];
            this.searchConditionForm = this.selectCloseSearchForm;
          }

          if (!!this.pbSupCode) {
            this.searchConditionForm.searchSupCode =
              this.pbSupCode.split(STR_COLON)[0];
          } else {
            this.searchConditionForm.searchSupCode =
              this.supCodeList[0]?.supCode;
          }

          this.searchClick();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        });
    },

    // 検索
    searchClick() {
      if (!this.showFlag) {
        this.showFlag = true;
      }
      //検索条件の処理
      this.updateSearchForm();

      searchCloseSelectForm({
        closeSelectSearchInfo: this.searchConditionForm,
        payNo: this.pbPayNo,
      })
        .then((res) => {
          this.cusPayCloseSelectTable = res.customerPayDetailInfoList;

          this.dataProcess();
          this.checkedProcess();
          //列幅の設定
          setColumnWidth(this.columns, this.cusPayCloseSelectTable);

          // 読み込み回数 = 1
          if (this.numLoads == 1) {
            this.$nextTick(() => {
              let data = this.$refs.cusPayCloseSelectTable.selection;

              // 比較用明細情報
              this.cmpDetailResult = JSON.parse(JSON.stringify(data));
            });

            // 読み込み回数 + 1
            this.numLoads = this.numLoads + 1;
          }

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })

        .finally(() => {
          this.showFlag = false;
        });
      // フォーカス削除
      this.$refs.searchBtn.$el.blur();
    },

    dataProcess() {
      this.cusPayCloseSelectTable.forEach((item) => {
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
        // item.pdSupplementAmount = formatStringToCurrency(
        //   item.pdSupplementAmount
        // );

        // 補足単価
        item.pdPayUPrice = formatStringToCurrency(item.pdPayUPrice);
        // 補足金額小計
        item.pdPayTotPrice = formatStringToCurrency(item.pdPayTotPrice);
        // UPD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
      });
    },

    //チェックボックスの選択処理
    checkedProcess() {
      if (!!this.tableData) {
        this.tableData.forEach((row) => {
          for (
            let index = 0;
            index < this.cusPayCloseSelectTable.length;
            index++
          ) {
            const element = this.cusPayCloseSelectTable[index];
            //詳細画面選択のデータ選択チェックボックス
            if (
              row.jrdOrderNo == element.jrdOrderNo &&
              row.jrdDetailNo == element.jrdDetailNo
            ) {
              this.$nextTick(() => {
                this.$refs.cusPayCloseSelectTable.toggleRowSelection(
                  this.cusPayCloseSelectTable[index],
                  true
                );
              });
            } else {
              continue;
            }
          }
        });
      }
    },

    updateSearchForm() {
      if (!!this.searchConditionForm.searchSupCode) {
        this.searchConditionForm.searchSupCode =
          this.searchConditionForm.searchSupCode.split(":")[0];
      }

      this.searchConditionForm.searchOrderNo =
        this.searchConditionForm.searchOrderNo.trim();
    },

    // ダイアログを閉じる
    // onCancel() {
    //   if (
    //     !cmpDetailData(
    //       this.cmpDetailResult,
    //       this.$refs.cusPayCloseSelectTable.selection
    //     )
    //   ) {
    //     return new Promise((resolve, reject) => {
    //       Modal.showWarning(
    //         "",
    //         t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
    //         {
    //           $type: "prompt",
    //           confirmButtonText: t("resource.button.sure"),
    //           cancelButtonText: t("resource.button.cancel"),
    //           showCancelButton: true,
    //         }
    //       )
    //         .then(() => {
    //           // 用户点击确认
    //           resolve(true);
    //         })
    //         .catch((error) => {
    //           // 用户点击取消或关闭对话框
    //           resolve(false);
    //         });
    //     });
    //   } else {
    //     return true;
    //   }
    // },

    //确定ボタン
    confirmClick() {
      let data = this.$refs.cusPayCloseSelectTable.selection;
      if (!!data && data.length > 0) {
        this.selectedProcForm = this.selectDataProcess(data);

        //同じ仕入先の検査
        if (!this.cusCodeCheck(data)) {
          Modal.showWarning("", t("message.CUS_PAY.SELECT_CUS_CODE_CHECK"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        } else {
          var result = [
            { key: "selectedProcForm", value: this.selectedProcForm },
            { key: "selectCloseSearchForm", value: this.searchConditionForm },
          ];
          this.$emit("ok", result);
          // });
        }
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      if (typeof this.$refs.confirmBtn !== "undefined") {
        // フォーカス削除
        this.$refs.confirmBtn.$el.blur();
      }
    },

    //同じ仕入先の検査
    cusCodeCheck() {
      const uniqueSupCodes = new Set(
        this.selectedProcForm.map((item) => item.pbSupCode)
      );
      return uniqueSupCodes.size === 1;
    },

    // 選択されたデータ処理
    selectDataProcess(data) {
      this.selectedProcForm = data;
      for (let index = 0; index < this.selectedProcForm.length; index++) {
        const element = this.selectedProcForm[index];

        if (!!element.pbSupCode) {
          // 仕入先
          element.pbSupCode = element.pbSupCode.split(":")[0];
        }
      }

      return data;
    },

    //セルの配置
    TableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 start↓
      if (
        (column.property === "pdPayQty" && row.pdPayQty < 0) ||
        (column.property === "pdPayTotPrice" &&
          formatCurrencyToNumber(row.pdPayTotPrice) < 0)
      ) {
        return "txt-cell-editable_red";
      }
      // ADD 2024/12/16 ZLL 課題_受注製品変更の検討 end↑
    },
    handleRowClick(row) {
      this.currentCell = row;
    },

    // 製品異常
    rowClassName({ row }) {
      if (!!row.odProdExKbn && row.odProdExKbn != STR_EMPTY) {
        if (row.odProdExKbn !== STR_ZERO) {
          return "textColor";
        }
      }
    },

    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },

    // 列幅に自動調整
    FlexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.cusPayCloseSelectTable);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
    // 課題_備考機能の追加
    //備考表示用
    formatRemarksShowProc(value) {
      return formatRemarksShow(value);
    },

    getIconTypeProc(value) {
      return getIconType(value);
    },

    // ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
    // 共通備考の調整（備考列幅の設定）
    getRemarksColumnWidthProc() {
      return getRemarksColumnWidth(this.cusPayCloseSelectTable);
    },
    // ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑
  },
};
</script>
<style scoped>
</style>
